import useHotjar from 'react-use-hotjar';

import { useIsMounted } from '@/_shared/hooks';

import { settings } from '../../_config';

declare global {
  interface Window {
    myCustomLogger: () => void;
  }
}

window.myCustomLogger = console.info;

export function useInitHotJar() {
  const { initHotjar, stateChange } = useHotjar();
  const isAllowed = settings.isProduction;

  useIsMounted(() => {
    if (isAllowed) {
      initHotjar(settings.atpHotjarApiKey, 6, false, window.myCustomLogger);
    }
  });

  return (pathname: string) => {
    if (isAllowed) {
      stateChange(pathname);
    }
  };
}

export function useIdentifyHotJar() {
  const { identifyHotjar } = useHotjar();
  const isAllowed = settings.isProduction && settings.isATP;

  return ({ email }: { email: string }) => {
    if (isAllowed) {
      identifyHotjar(email || 'email not found', { utcTimeStamp: new Date().toUTCString() }, window.myCustomLogger);
    }
  };
}
